import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import './styles/global.css'
import App from './App'
import { initializeFirebase } from './_data/firebase-init'

const rootElement = document.getElementById('root')

if (rootElement === null) {
  throw new Error('QuickPass root element not found in index.html')
}

initializeFirebase()

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
